import { Box, Button } from "@mui/material";
import React from "react";
import { useParams } from "react-router-dom";

interface HpListProps {
  listHP: any[];
}

const HpList: React.FC<HpListProps> = (props) => {
  const params = useParams();
  const id = params?.id as string;

  return (
    <Box className="flex flex-col md:flex-row py-5">
      {props.listHP.map((item, index) => (
        <Box key={index} className="mb-3 md:mb-0">
          <Button
            variant="contained"
            href={`/product-detail/${item.Href_Hash}`}
            key={index}
            className={
              id === item.Href_Hash
                ? "!bg-primary_blue !text-white !mx-1"
                : "!bg-transparent !text-primary_blue !mx-1"
            }
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              textTransform: "none",
            }}
          >
            <Box
              sx={{
                textTransform: "uppercase",
                fontSize: "14px",
                fontWeight: "bold",
              }}
            >
              {item.Name}
            </Box>
            <Box sx={{ fontSize: "12px" }}>{item.Desc}</Box>
          </Button>
        </Box>
      ))}
    </Box>
  );
};

export default HpList;
